import { mlAuto, title } from '../../coscef';

const totalStyle = {
  mlAuto,
  title: {
    ...title,
    marginBottom: 0,
  },
  textCenter: {
    textAlign: 'center!important',
  },
  features: {
    paddingTop: '30px',
  },
  titleRow: {
    marginTop: '-8vh',
  },
  floatRight: {
    float: 'right!important',
  },
  pickSize: {
    marginTop: '50px',
  },
  pullRight: {
    float: 'right',
  },
  moveTo: {
    marginTop: '30px',
  },
};

export default totalStyle;
